/**
 * Vozilo i vozač se NE biraju sami.
 *
 * Analiza 2.0 (P9), 14.10.2026: ekran je sam uzimao prvo vozilo (najveće) i
 * prvog slobodnog vozača, a podešavanja su tada stajala sklopljena — pa je
 * tura mogla da ode na pogrešnog vozača, kome po potvrdi odmah ode poruka.
 * Izbor je operaterov; dok ga nema, podešavanja stoje otvorena, a izabrano
 * piše u naslovu i kad su sklopljena.
 */

export interface VozacZaIzbor {
  id: number;
  fullName: string;
  isAvailable: boolean;
}

export interface VoziloZaIzbor {
  id: number;
  registration: string;
}

/**
 * Šta ostaje izabrano kad se promeni dan ture.
 *
 * Vozač koji tog dana ne radi se SKIDA, ne zamenjuje: zamena prvim slobodnim
 * bila bi ista greška kao i početni automatski izbor — čovek koji nije ništa
 * dirnuo dobio bi turu.
 */
export function vozacPoslePromeneDana(
  vozaci: readonly VozacZaIzbor[],
  driverId: number | null
): number | null {
  if (driverId === null) return null;
  const izabran = vozaci.find((d) => d.id === driverId);
  return izabran?.isAvailable ? driverId : null;
}

/** Naslov sklopljenih podešavanja: dan, vozilo i vozač — da se vidi i bez otvaranja. */
export function naslovPodesavanja(args: {
  danOpis: string;
  vozilo: VoziloZaIzbor | undefined;
  vozac: VozacZaIzbor | undefined;
}): string {
  const vozilo = args.vozilo ? args.vozilo.registration : 'vozilo nije izabrano';
  const vozac = args.vozac ? args.vozac.fullName : 'vozač nije izabran';
  return `Podešavanja ture — ${args.danOpis} · ${vozilo} · ${vozac}`;
}
